export const EVENTS = {
  BOOKMAKER: {
    DETAIL: {
      REFRESH: 'BOOKMAKER.DETAIL.REFRESH',
      REFRESHING: 'BOOKMAKER.DETAIL.REFRESHING',
      REFRESHED: 'BOOKMAKER.DETAIL.REFRESHED',
      REFRESH_ERROR: 'BOOKMAKER.DETAIL.REFRESH_ERROR'
    },
    SELECT_BOOKMAKER_ID_TO_CHANGE: 'bookmaker.SELECT_BOOKMAKER_ID_TO_CHANGE',
    REQUEST_ACCOUNT_CONFIRMATION: 'bookmaker.REQUEST_ACCOUNT_CONFIRMATION',
    BOOKMAKER_ID_CONFIRMED: 'bookmaker.BOOKMAKER_ID_CONFIRMED',
    REQUEST_BOOKMAKER_ID_CHANGE: 'bookmaker.REQUEST_BOOKMAKER_ID_CHANGE',
    BOOKMAKER_ID_CONFIRMATION_CANCELED:
      'bookmaker.BOOKMAKER_ID_CONFIRMATION_CANCELED'
  }
};

export const ENDPOINTS = {
  BOOKMAKER: {
    GET_LIST:
    "https://api.kingrecharges.com/bookmaker/player/{bookmaker}/{accountId}?group=lacasae&service=1xpay&currency=xof"
  }
};

export const BOOKMAKER = {
  INFOS: {
    '1xbet': {
      id: '1xbet',
      name: '1xBet',
      logo: '/images/services/1xBetIco.svg',
      idScreenshot: '/images/screenshots/1xbet-account-id-getting.webp'
    },
    '1win': {
      id: '1win',
      name: '1Win',
      logo: '/images/services/1winIcon.svg',
      idScreenshot: '/images/screenshots/1win-account-id-getting.webp'
    },
    betwinner: {
      id: 'betwinner',
      name: 'Betwinner',
      logo: '/images/services/betwinner-full.png',
      idScreenshot: '/images/screenshots/betwinner-account-id-getting.webp'
    },
    melbet: {
      id: 'melbet',
      name: 'Melbet',
      logo: '/images/services/melbetIcon.svg',
      idScreenshot: '/images/screenshots/melbet-account-id-getting.png'
    },
    eightStarz: {
      id: 'eightStarz',
      name: '888Starz',
      logo: '/images/services/eightStarz.png',
      idScreenshot: '/images/screenshots/eightStarz-account-id-getting.webp'
    }
  }
};
